export class Telemetry {
    rssi = 0;
    freq = 0;
    snr = 0;
    channel_width = 0;
}
